import React from 'react'

import SearchBar from '../SearchBar'
import '../../styles/pages/404.scss'


const NotFound = (props) => {


	return (

		<div className="dull-back error_404">
			<SearchBar />
			<div className="welcome__wrapper content-block">
				<h1 className="welcome__header">404 NOT FOUND</h1>
				<hr className="divider" />
				<h2 className="welcome__subheader">Please check the URL you have entered. Alternatively use the search box or browse using the site menu.</h2>
			</div>
		</div>
	)
}

export default NotFound
